import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Review from "./Review";
import { linkedinProfileLinks } from "../constants/External";

function ReviewsCarousel(props) {
  const { handlePageChange, isSmallScreen } = props;

  const settings = {
    className: "center",
    dots: true,
    centerMode: true,
    infinite: true,
    centerPadding: isSmallScreen ? "20px" : "50px",
    slidesToShow: isSmallScreen ? 1 : 3,
    speed: 500
  };
  return (
    <div className="slider-container" style={{ width: isSmallScreen ? "95%" : "100%", margin: "auto" }}>
      <Slider {...settings}>
        <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Anil Shrivastava"}
            url={linkedinProfileLinks[0]}
            link={"https://www.linkedin.com/in/anil-shrivastava-7768b6334/"}
            designation={"Cloud Engineer"}
            company={"Hewlett Packard Enterprise"}
            content={"My career has completely changed since I enrolled in PaperLive Learning's DevOps and Cloud Training! Under the direction of knowledgeable experts, the seminar provided a thorough examination of important ideas and resources. The practical projects gave us priceless real-world experience, and our partnership with Microsoft made sure we were abreast of the most recent developments in the field. To anyone hoping to progress in the tech industry, I heartily suggest this program!"}
          />
        </div>
        <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Dilip Mehta"}
            url={linkedinProfileLinks[1]}
            link={"https://www.linkedin.com/in/dilip-mehta-110615332/"}
            designation={"DevOps Engineer"}
            company={"PhonePe"}
            content={"The DevOps training I received from PaperLive Learning fundamentally changed the way I think about software development and deployment. The course creates a solid connection between development and operations by covering everything from fundamental to complex subjects. Complex ideas were explained by knowledgeable professors, and practical experience was gained through interactive labs and real-world case studies. An absolute game-changer for anyone trying to become an expert in DevOps!"}
          />
        </div>
        {/* <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Soubhagya Ranjan Sethy"}
            url={linkedinProfileLinks[2]}
            link={"https://www.linkedin.com/in/soubhagya-ranjan-sethy-4120a819b/"}
            designation={"Software Engineer"}
            company={"TCS"}
            content={"Paperlive Learning’s DevOps training transformed my grasp of software development and deployment. Covering basic to advanced topics, the course effectively bridges development and operations teams. Expert instructors made complex concepts accessible, and hands-on labs plus real-world case studies provided practical experience. A game-changer for mastering DevOps."}
          />
        </div> */}
        <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Suraj Sharma"}
            url={linkedinProfileLinks[3]}
            link={"https://www.linkedin.com/in/suraj-sharma-4b04b7332/"}
            designation={"DevOps Engineer"}
            company={"Concentrix"}
            content={"I thoroughly enjoyed this course on DevOps and Cloud! The instructor provided exceptional support at every stage and was quite knowledgeable. Additionally, the Support Team was very quick to respond and always willing to help with any issues or queries. For anyone looking to improve their DevOps skills, I heartily suggest this course!"}
          />
        </div>
        <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Zaid Hassmi"}
            url={linkedinProfileLinks[4]}
            link={"https://www.linkedin.com/in/zaid-hassmi-6627891bb/"}
            designation={"Associate Analyst"}
            company={"Deloitte"}
            content={"I had a great time with this DevOps and Cloud course. The instructor was incredibly knowledgeable and provided excellent support throughout. The Support Team was responsive and always ready to help with any issues or questions. Highly recommend this course for anyone looking to advance their DevOps skills!"}
          />
        </div>
        <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Sridevi Rao"}
            url={linkedinProfileLinks[5]}
            link={"https://www.linkedin.com/in/sridevi-rao-323810331/"}
            designation={"DevOps Engineer"}
            company={"Cognizant"}
            content={"This training was a great learning experience because it was comprehensive and practical. We are really grateful to the instructor for their exceptional help and for going above and beyond to make sure everything was understood. Additionally, the Support Team was excellent; they were always timely and helpful in answering any questions I had. I heartily suggest this course to anyone who wants to become more proficient in DevOps!"}
          />
        </div>
        <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Syed Shayan Ali"}
            url={linkedinProfileLinks[6]}
            link={"https://www.linkedin.com/in/syed-shayan-ali-793152230/"}
            designation={"Consultant"}
            company={"SAP"}
            content={"Exceptional DevOps Engineer Course - Highly Recommended!'The course was thorough and hands-on, offering a great learning experience. A huge thanks to the instructor for their excellent support and extra effort to ensure I understood everything. The Support Team was also fantastic, providing prompt responses and helpful guidance on every question I had."}
          />
        </div>
        <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Sameer Suman"}
            url={linkedinProfileLinks[7]}
            link={"https://www.linkedin.com/in/sameer-suman-bb1b33335/"}
            designation={"Cloud Engineer"}
            company={"CRED"}
            content={"I discovered that PaperLive provides great assistance, such as one-on-one mentoring sessions and a variety of code tasks, to help close the knowledge gap because I don't have a technical background. I found these elements to be quite helpful in getting ready for interviews with big tech companies. I heartily suggest it to anyone wishing to enter the tech sector!"}
          />
        </div>
        <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Anant Kumar"}
            designation={"Project Engineer"}
            company={"Wipro"}
            link={"https://www.linkedin.com/in/anant-kumar46/"}
            url={linkedinProfileLinks[8]}
            content={"Paperlive offers exceptional features, including one-on-one mentorship sessions and a variety of coding problems, to help you prepare for interviews with major companies."}
          />
        </div>
        <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Hamza Imam"}
            url={linkedinProfileLinks[9]}
            link={"https://www.linkedin.com/in/hamza-imam-4634a9335/"}
            designation={"DevOps Engineer"}
            company={"Wipro"}
            content={"Outstanding features offered by Paperlive include comprehensive practical sessions, individualised one-on-one mentoring, and a variety of code problems to assist you prepare for interviews with leading businesses."}
          />
        </div>
        <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Ayush Raj"}
            designation={"Data Analyst"}
            link={"https://www.linkedin.com/in/ayush-raj-b4663a251/"}
            company={"Accenture"}
            content={"Originally from a non-tech background, I found that Paperlive provides outstanding features, such as one-on-one mentorship sessions and numerous coding problems, to help bridge the gap and prepare me for interviews with major tech companies."}
            url={linkedinProfileLinks[10]}
          />
        </div>
        <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Wasil Hasnain"}
            designation={"Software Engineer"}
            content={"Paperlive provides outstanding features, such as full practical sessions, personalized one-on-one mentorship, and a wide range of coding problems to help you get ready for interviews with top companies."}
            link={"https://www.linkedin.com/in/wasil-hasnain-77a140193/"}
            company={"Lowe's India"}
            url={linkedinProfileLinks[11]}
          />
        </div>
        <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Apurva Raj"}
            url={linkedinProfileLinks[12]}
            link={"https://www.linkedin.com/in/apurva-raj-56439b1b0/"}
            designation={"Analyst"}
            company={"Capgemini"}
            content={"Securing a job without adequate experience in AWS and DevOps technologies was challenging. However, after completing the Cloud and Job Ready Programme online course with Paperlive, I gained the necessary knowledge to successfully ace my interview."}
          />
        </div>
        <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Farzil Hai"}
            url={linkedinProfileLinks[13]}
            link={"https://www.linkedin.com/in/farzil-hai-40a961324/"}
            designation={"System Engineer"}
            company={"Qualcomm"}
            content={"It was difficult to find employment without sufficient knowledge of AWS and DevOps technologies. But after finishing Paperlive's Cloud and Job Ready Programme online course, I acquired the skills I needed to ace my interview."}
          />
        </div>
        <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Waquar Ali Asghar"}
            url={linkedinProfileLinks[14]}
            link={"https://www.linkedin.com/in/waquar-ali-asghar-207428190/"}
            designation={"QA Engineer"}
            company={"Credit Saison"}
            content={"I had the pleasure of participating in the DevOps and Cloud Training program with Paperlive Learning, in collaboration with Microsoft, and it was an outstanding experience! The curriculum was well-structured and packed with relevant, hands-on projects that truly enhanced my understanding of modern DevOps practices and cloud solutions. The instructors were knowledgeable and supportive, fostering an engaging learning environment. I left the program feeling empowered and equipped with the skills to excel in my career. I highly recommend Paperlive Learning to anyone looking to elevate their tech expertise!"}
          />
        </div>
        <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Akhil Bhatt"}
            url={linkedinProfileLinks[15]}
            link={"https://www.linkedin.com/in/akhil-bhatt-a69b13335/"}
            designation={"Automation Engineer"}
            company={"Oracle"}
            content={"It was an amazing experience for me to take part in Paperlive Learning's DevOps and Cloud Training program, which was organised in partnership with Microsoft! I gained a deeper understanding of contemporary DevOps techniques and cloud solutions thanks to the curriculum's organisation and abundance of pertinent, practical projects. An interesting learning atmosphere was created by the experienced and encouraging lecturers. After completing the training, I felt empowered and prepared to succeed in my work. Anybody wishing to improve their tech skills should definitely check out Paperlive Learning!"}
          />
        </div>
        <div>
          <Review isSmallScreen={isSmallScreen}
            name={"Eyon Utkarsh"}
            url={linkedinProfileLinks[16]}
            link={"https://www.linkedin.com/in/eyon-utkarsh-02b594175/"}
            designation={"Senior Application Developer"}
            company={"Standard Chartered"}
            content={"Participating in the DevOps and Cloud Training with Paperlive Learning was a game-changer for my career! The course provided a deep dive into essential concepts and tools, all while being guided by experienced professionals. I particularly enjoyed the collaborative projects, which gave me real-world experience. The partnership with Microsoft ensured we were learning the most current practices in the field. I wholeheartedly recommend this program to anyone eager to grow in the tech industry!"}
          />
        </div>
      </Slider>
    </div>
  );
}

export default ReviewsCarousel;
